<template>
  <div>
    <v-form>
      <h2 class="mb-5">Identifying an Unknown Acid - Report Sheet</h2>

      <p class="mb-3">a) Fill out the following table with the results from your experiment.</p>

      <v-simple-table class="mb-6 pl-3">
        <thead>
          <tr>
            <td><stemble-latex content="$\text{Property}$" /></td>
            <td style="text-align: center; font-weight: bold">Value</td>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>i) Mass of Acid (g)</td>
            <td class="centered-input">
              <calculation-input
                v-model="inputs.massAcid"
                class="my-2"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>
              ii) Volume of NaOH needed to reach equivalence point,
              <stemble-latex content="$\text{V}_\text{eq}$" /> (mL)
            </td>
            <td class="centered-input">
              <calculation-input
                v-model="inputs.Veq"
                class="my-2"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>iii) [NaOH] (M)</td>
            <td class="centered-input">
              <calculation-input
                v-model="inputs.concNaOH"
                class="my-2"
                :show-scientific-notation="false"
                placeholder="0.100"
                disabled="true"
              />
            </td>
          </tr>

          <tr>
            <td>iv) Moles of unknown acid (mol)</td>
            <td class="centered-input">
              <calculation-input
                v-model="inputs.molAcid"
                class="my-2"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>v) Molar mass of acid (g/mol)</td>
            <td class="centered-input">
              <calculation-input
                v-model="inputs.mwAcid"
                class="my-2"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>vi) pH at half-equivalence point</td>
            <td class="centered-input">
              <calculation-input
                v-model="inputs.pHHalfVeq"
                class="my-2"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>vii) <stemble-latex content="$\text{K}_\text{a}$" /> of acid</td>
            <td class="centered-input">
              <calculation-input
                v-model="inputs.Ka"
                class="my-2"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <p class="mb-n3">
        b) Based on the your data analysis above, what is the identity of your acid?
      </p>

      <v-radio-group v-model="inputs.acidIdentity" :disabled="!allowEditing" class="mb-0 pl-6">
        <v-radio
          v-for="option in options"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import STextarea from '@/common/components/STextareaShort.vue';

export default {
  name: 'OleMiss_UnknownAcid_ReportSheet',
  components: {STextarea, CalculationInput, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        massAcid: null,
        Veq: null,
        concNaOH: null,
        molAcid: null,
        mwAcid: null,
        pHHalfVeq: null,
        Ka: null,
        acidIdentity: null,
      },
      options: [
        {
          text: 'Sodium dihydrogen phosphate',
          value: 'dihydrogenPhosphateAnion',
        },
        {
          text: 'Potassium hydrogen sulfate',
          value: 'hydrogenSulfateAnion',
        },
        {
          text: 'Sodium hydrogen sulfite',
          value: 'hydrogenSulfiteAnion',
        },
      ],
    };
  },
};
</script>
